import { Card, Grid, Modal, Text } from "@mantine/core";
import QueryString from "qs";
import React, { useState } from "react";
import useSWR from "swr";
import Lightbox from "yet-another-react-lightbox";
import { Zoom } from "yet-another-react-lightbox/plugins";

export default function InternalCompanyDetailModalV2({ companyId, close }) {
  const [openLightboxIndex, setOpenLightboxIndex] = useState(null);

  const params = QueryString.stringify({
    populate: ["internalImages"],
  });

  const { data } = useSWR(companyId ? [`/companies/${companyId}`, params] : null);

  const item = data?.data?.attributes || {};
  const images = item?.internalImages?.data?.map((i) => ({ src: i.attributes.url })) || [];

  return (
    <Modal opened={!!companyId} onClose={close} title="내부 메모" size="xl">
      <Lightbox
        index={openLightboxIndex}
        open={openLightboxIndex === null ? false : true}
        close={() => setOpenLightboxIndex(null)}
        slides={images}
        plugins={[Zoom]}
        zoom={{ maxZoomPixelRatio: 10 }}
      />
      <Grid>
        <Grid.Col span={12} md={6}>
          <Card shadow="0" p="xs">
            <Text size="sm" sx={{ whiteSpace: "break-spaces" }}>
              {item?.internalMemo}
            </Text>
          </Card>
        </Grid.Col>

        <Grid.Col span={12} md={6}>
          {/* <Card>
              {images.length > 0 && (
                <div style={{ width: "100%" }}>
                  <Carousel withIndicators>
                    {images.map((image) => {
                      return (
                        <Carousel.Slide key={image.src} width="100%">
                          <Image
                            src={image.src}
                            alt={image.src}
                            onClick={() => setOpenLightbox(true)}
                            // height={100}
                            // width={320}
                            width="100%"
                            // style={{ objectFit: "contain", width: "100%" }}
                          />
                        </Carousel.Slide>
                      );
                    })}
                  </Carousel>
                </div>
              )}
            </Card> */}
          {item?.internalImages?.data?.map((image, idx) => {
            return (
              <Card key={image.id} shadow="0" p="xs" sx={{ position: "relative" }} mb="xs">
                <img
                  src={image?.attributes?.url}
                  alt={image.id}
                  onClick={() => setOpenLightboxIndex(idx)}
                  // height={100}
                  style={{ objectFit: "contain", width: "100%" }}
                />
              </Card>
            );
          })}
        </Grid.Col>
      </Grid>
    </Modal>
  );
}

// 내부 메모
//
